/** @format */

import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import LoadingScreen from 'src/components/LoadingScreen';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  fadeIn: {
    position: 'relative',
    animation: `$fadeInAnimation 0.5s ease`
  },
  '@keyframes fadeInAnimation': {
    from: { opacity: 0, top: '24px' },
    to: { opacity: 1, top: '0' }
  }
}));

export default function UpdateTicketLoading() {
  const [step, setStep] = useState(0);
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    const timers = [
      setTimeout(() => setStep(1), 0),
      setTimeout(() => setStep(2), 5000),
      setTimeout(() => setStep(3), 10000)
    ];

    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <Box className="create-ticket-loader">
      <Box className="create-ticket-loading-icon">
        <LoadingScreen />
      </Box>
      {step === 1 && <p className={classes.fadeIn}>🚀 {t('Tickets.waitingText01')}</p>}
      {step === 2 && <p className={classes.fadeIn}>⏱️ {t('Tickets.waitingText02')}</p>}
      {step === 3 && <p className={classes.fadeIn}>🏁 {t('Tickets.waitingText03')}</p>}
    </Box>
  );
}
